const formatSizes = [
  {
    id: 1,
    name: 'Facebook Image',
    description: '1200 x 1200',
    size: {
      width: 1200,
      height: 1200,
    },
  },
  {
    id: 2,
    name: 'Facebook Link',
    description: '1200 x 627',
    size: {
      width: 1200,
      height: 627,
    },
  },
  {
    id: 3,
    name: 'Facebook Cover',
    description: '820 x 312',
    size: {
      width: 820,
      height: 312,
    },
  },
  {
    id: 4,
    name: 'Facebook Mobile Cover',
    description: '640 x 360',
    size: {
      width: 640,
      height: 360,
    },
  },
  {
    id: 5,
    name: 'Facebook Story',
    description: '1080 x 1920',
    size: {
      width: 1080,
      height: 1920,
    },
  },
  {
    id: 6,
    name: 'Instagram Story',
    description: '1080 x 1920',
    size: {
      width: 1080,
      height: 1920,
    },
  },
  {
    id: 7,
    name: 'Instagram Post',
    description: '1080 x 1080',
    size: {
      width: 1080,
      height: 1080,
    },
  },
  {
    id: 8,
    name: 'Twitter Post',
    description: '1024 x 521',
    size: {
      width: 1024,
      height: 512,
    },
  },
  {
    id: 9,
    name: 'Twitter Banner',
    description: '1500 x 500',
    size: {
      width: 1500,
      height: 500,
    },
  },
  {
    id: 10,
    name: 'Pinterest Post',
    description: '736 x 1128',
    size: {
      width: 736,
      height: 1128,
    },
  },
  {
    id: 11,
    name: 'Email Header',
    description: '600 x 300',
    size: {
      width: 600,
      height: 300,
    },
  },
  {
    id: 12,
    name: 'Presentation',
    description: '1024 x 768',
    size: {
      width: 1024,
      height: 768,
    },
  },
  {
    id: 13,
    name: 'Coupon',
    description: '1800 x 750',
    size: {
      width: 1800,
      height: 750,
    },
  },
  {
    id: 13,
    name: 'Coupon',
    description: '1800 x 750',
    size: {
      width: 1800,
      height: 750,
    },
  },
]

export default formatSizes
